// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DataItemListModel from '../../model/data-item-list-model';
import DataItemListDTO from '../dto/data-item-list-dto';
import dtoSchema from '../schemas/data-item-list-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class DataItemListModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DataItemListDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.title = data.title ?? undefined;
      this.subTitle = data.subTitle ?? undefined;
      this.comment = data.comment ?? undefined;
      this.pictureDocumentExternalId = data.pictureDocumentExternalId ?? undefined;
      this.statusId = data.statusId;
      this.statusCaption = data.statusCaption ?? undefined;
      this.categoryId = data.categoryId;
      this.categoryCaption = data.categoryCaption ?? undefined;
      this.validFrom = data.validFrom ?? undefined;
      this.validUntil = data.validUntil ?? undefined;
      this.contentTypeId = data.contentTypeId ?? undefined;
      this.contentTypeCaption = data.contentTypeCaption ?? undefined;
      this.searchTerms = data.searchTerms ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  */
  creatorName?: string;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  */
  modifierName?: string;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  */
  title?: string;
  /**
  */
  subTitle?: string;
  /**
  */
  comment?: string;
  /**
  */
  pictureDocumentExternalId?: string;
  /**
  * @type {int64}
  */
  statusId?: number;
  /**
  */
  statusCaption?: string;
  /**
  * @type {int64}
  */
  categoryId?: number;
  /**
  */
  categoryCaption?: string;
  /**
  * @type {date-time}
  */
  validFrom?: string;
  /**
  * @type {date-time}
  */
  validUntil?: string;
  /**
  * @type {int64}
  */
  contentTypeId?: number;
  /**
  */
  contentTypeCaption?: string;
  /**
  */
  searchTerms?: string;

  static toModel(dto: DeepPartial<DataItemListDTO>): DataItemListModel;
  static toModel(dto: DeepPartial<DataItemListDTO> | undefined | null): DataItemListModel | undefined;
  static toModel(dto: DeepPartial<DataItemListDTO> | undefined | null): DataItemListModel | undefined {
    return dto ? new DataItemListModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DataItemListModel> | DataItemListModel): DataItemListDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      creatorId: unwrapped.creatorId,
      creatorName: unwrapped.creatorName,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modifierName: unwrapped.modifierName,
      modified: unwrapped.modified,
      title: unwrapped.title,
      subTitle: unwrapped.subTitle,
      comment: unwrapped.comment,
      pictureDocumentExternalId: unwrapped.pictureDocumentExternalId,
      statusId: unwrapped.statusId,
      statusCaption: unwrapped.statusCaption,
      categoryId: unwrapped.categoryId,
      categoryCaption: unwrapped.categoryCaption,
      validFrom: unwrapped.validFrom,
      validUntil: unwrapped.validUntil,
      contentTypeId: unwrapped.contentTypeId,
      contentTypeCaption: unwrapped.contentTypeCaption,
      searchTerms: unwrapped.searchTerms,
    } as DataItemListDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DataItemListModel, can not map to DataItemListDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
